import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import routes from "./routes/routes";
// import AdminSidebar from "./components/sidebar";
// import AdminSidebar from "./components/ui/sidebar";
// import AdminHeader from "./components/header";
// import AdminHeader from "./components/ui/header";
import Layouts from "./components/layouts/mainLayout.jsx";
import PrivateRoute from "./services/privateRoutes";
import UpdatePrompt from "./components/ui/UpdatePrompt";
import LegacyAppNotice from "./components/ui/LegacyAppNotice";
import { isLegacyErpApp } from "./services/chatApp";

const AppContent = () => {
  const location = useLocation();
  const isProtectedView = ["/admin", "/employee", "/hr", "/profile", "/notices"].some((prefix) => location.pathname.startsWith(prefix));

  const renderRoutes = (routesArray, isProtected = false) =>
    routesArray.map(({ path, element: Element, allowedRoles = [] }) => (
      <Route
        key={path}
        path={path}
        element={
          isProtected ? (
            <PrivateRoute allowedRoles={allowedRoles}>
              <Element />
            </PrivateRoute>
          ) : (
            <Element />
          )
        }
      />
    ));

  // The old installed ERP app is discontinued: point its users to IRG Chat and the browser.
  if (isLegacyErpApp(location.pathname)) return <LegacyAppNotice />;

  return (
    <div className="App">
      {/* {isProtectedView && <AdminSidebar />} */}
      <div>
        {/* {isProtectedView && <AdminHeader />} */}
        <Layouts isProtectedView={isProtectedView} >
          {/* Phones: bottom padding clears the tab bar (ui/MobileNav.jsx) and the home indicator. */}
          <main className={isProtectedView ? "p-3 pb-[calc(4.5rem+env(safe-area-inset-bottom))] md:p-5" : undefined}>
            <Routes>
              {renderRoutes(routes.public || [])}
              {renderRoutes(routes.admin || [], true)}
              {renderRoutes(routes.employee || [], true)}
              {renderRoutes(routes.hr || [], true)}
              {renderRoutes(routes.profile || [], true)}
              {renderRoutes(routes.notices || [], true)}
            </Routes>
          </main>
        </Layouts>
      </div>
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
      <UpdatePrompt />
    </Router>
  );
}

export default App;
